<template>
  <div class="mb-3">
      <table class="table table-striped">
      <thead>
        <tr>
          <th>Magic Variable</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in magicVariables" :key="index">
          <td>{{ item.variable }}</td>
          <td>{{ item.description }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>

export default {
  name: "MagicVariables",
  data: function() {
    return {
      magicVariables: [
        {
          variable: "callback_data",
          description:
            "This variable contains callback data of the user pressed Inline callback button"
        },
        {
          variable: "callback_message_text",
          description:
            "This variable contains text of the message that is attatched with the user pressed Inline callback button"
        },
        {
          variable: "caption",
          description:
            "This variable contains caption of the incoming media message."
        },
        {
          variable: "chat_id",
          description: `This variable contains id of the chat from which incoming message is generated, It can be user Id/channel Id/group Id`
        },
        {
          variable: "chat_invite_link",
          description: `This variable will hold the chat invite link with which a single user can join the private chat.`
        },
        {
          variable: "command_argument",
          description:
            "This variable contains the argument of the command that is used to call the bot. For example, if the user entered '/get current price' then this variable will contain 'current price'."
        },
        {
          variable: "date",
          description: "This variable contains date and time of incoming message."
        },
        {
          variable: "file_id",
          description:
            "This variable contains id of the incoming media file (photo/video/voice/document/animation/..)."
        },
        {
          variable: "first_name",
          description:
            "This variable contains the first name of the user from whom incoming message is generated."
        },
        {
          variable: "forward_from_chat_first_name",
          description:
            "For forwarded messages, first name of the sender of the original message"
        },
        {
          variable: "forward_from_chat_id",
          description:
            "For forwarded messages, id of the sender/channel of the original message"
        },
        {
          variable: "forward_from_chat_last_name",
          description:
            "For forwarded messages, last name of the sender of the original message"
        },
        {
          variable: "forward_from_chat_title",
          description:
            "For forwarded messages, title of the channel of the original message"
        },
        {
          variable: "forward_from_chat_type",
          description:
            "For forwarded messages, chat type of the sender of the original message, Ex: private, channel, group"
        },
        {
          variable: "forward_from_chat_username",
          description:
            "For forwarded messages, username of the channel of the original message"
        },
        {
          variable: "http_result",
          description:
            "This variable contains result of the 'HttpRequest' method as json object or in text format."
        },
        {
          variable: "incoming_message_id",
          description: "This variable contains id of the incoming message."
        },
        {
          variable: "last_name",
          description:
            "This variable contains last name of the user from whom incoming message is generated."
        },
        {
          variable: "leaderboard",
          description:
            "This variable contains result of the 'Leaderboard' task, Leaderboard of the top referrals to channel or group."
        },
        {
          variable: "message",
          description: "This variable contains original message fields. refer https://core.telegram.org/bots/api#message"
        },
        {
          variable: "prime_member_status",
          description: "It can be 'Active', 'Expired' or 'Inactive'. Active : Prime member and currently prime membership is active, Expired: Prime member and currently membership is expired, Inactive: Not a prime member."
        },
        {
          variable: "prime_member_validity",
          description: "Date at which prime membership will expire."
        },
        {
          variable: "referrals",
          description: "This variable contains total referrals of the user."
        },
        {
          variable: "referral_link",
          description: "This variable contains referral link of the user."
        },
        {
          variable: "outgoing_message_id",
          description: "This variable contains id of the outgoing message."
        },
        {
          variable: "user_id",
          description:
            "This variable contains id of the user from whom incoming message is generated."
        },
        {
          variable: "user_input",
          description: "This variable contains text of the incoming message."
        },
        {
          variable: "username",
          description: `This variable contains username of the user from whom incoming message is generated. set to None if user don't have username.`
        }
      ]
    };
  }
};
</script>
